export default "/images/a_rank.webp?84642132b09316c9f52dd6eeccabe89f";